import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, Attribute, ViewChild
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl, AbstractControl, Validator, ValidatorFn
} from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {FileInfo, FileRestrictions, SelectEvent, UploadComponent} from '@progress/kendo-angular-upload';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {UserContext} from '../../../../services/user-context';
import {ApiService} from '../../../../services/api';
import {Observable} from 'rxjs';
import {GridDataResult} from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-import-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'import-dialog.template.html'
})

export class ImportDialogComponent implements OnInit {
  @ViewChild('uploader', { static: true }) public uploader: UploadComponent;

  public view: Observable<GridDataResult>;

  upload:any;
  location:any;
  locations: any[] = [];
  selectedFile:FileInfo;
  uploadUrl = '';
  loading = false;
  uploadRestrictions: FileRestrictions = {
    allowedExtensions: ['.xls', '.xlsx', '.csv']
  };

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<ImportDialogComponent>,
              private userContext: UserContext,
              public httpClient: HttpClient,
              private api: ApiService,
              @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  public ngOnInit(): void {
    this.api.get<any>(`/account/${(this.userContext.account || {}).id}/location`)
      .subscribe(locations => {
        if (locations) {
          this.locations = locations;
        }
      });
  }

  public clearEventHandler(): void {
    this.selectedFile = null;
  }

  public selectEventHandler(e: SelectEvent): void {
    const that = this;

    e.files.forEach((file) => {
      console.log(`File selected: ${file.name}`);
      this.selectedFile = file;
    });
  }

  public isAdministrator() {
    return this.userContext.hasRole('administrator');
  }

  public save() {
    if( this.selectedFile ) {
      console.log("Saving " + this.selectedFile.name + " with extension: " + this.selectedFile.extension);
      this.loading = true
      this.api.post<any>(`/account/${this.userContext.user.account_id}/import`,
        {
          location: this.location.id,
          contentType: this.selectedFile.rawFile.type,
          fileName: this.selectedFile.name
        }
      ).subscribe( result => {
        this.upload = result;
        console.log("Url: " + JSON.stringify(result));

        let formData = new FormData();
        for (let key of Object.keys(this.upload.post.fields) ){
          formData.append(key, this.upload.post.fields[key])
        }
        formData.append("file", this.selectedFile.rawFile);

        this.httpClient.post(this.upload.post.url, formData ).subscribe(next => {
          this.loading = false;
          this.dialogRef.close(this.upload);
        }, error => {
          this.loading = false;
          console.log("Received error: " + JSON.stringify(error));
        });
      }, (error) => {
        this.loading = false;
        console.log("Error getting upload url");
      });

    }
  }

  public cancel() {
    this.dialogRef.close();
  }
}
